import { EShipmentsActionTypes, TShipmentsAction, TShipments } from '../types/shipments.types';

export const setShipments = (shipments: TShipments): TShipmentsAction => ({
  type: EShipmentsActionTypes.SHIPMENTS_SET_STATE,
  payload: shipments,
});
